import * as yup from "yup";

export const ConfigurarConsultaNotaFiscalSchema = yup.object().shape({
  usuarioPrefeitura: yup.string().nullable(),

  senhaPrefeitura: yup.string().nullable(),

  senhaCertificadoDigital: yup.string().nullable(),

  mailReaderEmail: yup.string().nullable(),

  mailReaderPassword: yup.string().nullable(),
});
